import React, { ReactNode, useEffect, useState } from "react";

interface ClaudeChatLayoutProps {
  isMobileView: boolean;
  showSidebar: boolean;
  sidebarComponent: ReactNode;
  mainComponent: ReactNode;
}

const ClaudeChatLayout: React.FC<ClaudeChatLayoutProps> = ({
  isMobileView,
  showSidebar,
  sidebarComponent,
  mainComponent,
}) => {
  // État pour détecter les changements d'orientation de l'écran
  const [orientation, setOrientation] = useState<"portrait" | "landscape">(
    window.innerHeight > window.innerWidth ? "portrait" : "landscape"
  );

  // Détecter les changements d'orientation
  useEffect(() => {
    const handleResize = () => {
      const isPortrait = window.innerHeight > window.innerWidth;
      setOrientation(isPortrait ? "portrait" : "landscape");
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("orientationchange", () => {
      // Petit délai pour s'assurer que les dimensions sont mises à jour
      setTimeout(handleResize, 100);
    });

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("orientationchange", handleResize);
    };
  }, []);

  // Une fonction pour générer des classes en fonction de l'état
  const getLayoutClasses = () => {
    // Utiliser l'orientation pour ajuster les classes si nécessaire
    const isPortrait = orientation === "portrait";

    return {
      container: "w-full flex mt-2", // Ajout de mt-2 pour l'espace sous la navbar
      sidebar: `${isMobileView && !showSidebar ? "hidden" : ""} 
                ${
                  isMobileView
                    ? "fixed inset-0 z-40 bg-base-100 mt-16" // Ajusté z-40 et mt-16 pour passer sous la navbar
                    : "w-80 min-w-[280px] flex-shrink-0"
                }
                ${isPortrait && isMobileView ? "h-[calc(100%-4rem)]" : ""}`, // Soustrait la hauteur de la navbar
      main: `flex-grow 
             ${!showSidebar || !isMobileView ? "block" : "hidden md:block"}`,
    };
  };

  const classes = getLayoutClasses();

  return (
    <div
      className={`${classes.container}`}
      style={{ height: "calc(100vh - 120px)" }}
    >
      {/* Sidebar */}
      {(showSidebar || !isMobileView) && (
        <div className={classes.sidebar}>{sidebarComponent}</div>
      )}

      {/* Main content */}
      <div className={classes.main}>{mainComponent}</div>
    </div>
  );
};

export default ClaudeChatLayout;
